export const blockIconsHardwareDeveloperBoard = (
	<span className='material-symbols-outlined'>developer_board</span>
);
